import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { getCurrentOverviewPage } from 'actions/partnerPlanAdmin'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { headerTitleName } from 'utils/headerTitleName'
import { commonFunctions } from 'utils/CommonFunctions'

class PartnerPlans extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    getCurrentOverviewPage: PropTypes.func,
    partnerSideBarInfo: PropTypes.object,
    routes: PropTypes.instanceOf(Array),
    // eslint-disable-next-line react/no-unused-prop-types
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    routes: {},
    partnerSideBarInfo: null,
    getCurrentOverviewPage: null,
    selectedPartner: null,
    currentUser: null,
  }

  componentDidMount() {
    const { currentUser } = this.props
    // this.props.getPageHtmlContent(getConfig().PAGE_TEMPLATE_LIBRARY, 'PartnerPlan', currentUser.EmployeeId)
    this.props.getCurrentOverviewPage(currentUser.EmployeeId)
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Partner plan'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  showSidebar() {
    const locationPath = this.props.location.pathname
    const { routes } = this.props
    const currentRouteData = (routes.find(i => i.path === locationPath) || {}).data
    if (!currentRouteData || currentRouteData.showSidebar === null) { return true }

    return currentRouteData.showSidebar
  }

  render() {
    const { routes, partnerPlanAdmin, currentUser } = this.props
    return (
      <MainLayout
        bannerNavProps={{ ...this.bannerProps() }}
        partnerPlanSideNav={partnerPlanAdmin.partnerPlanOverviewPage.sidebar}
        partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
        showSidebar={this.showSidebar()}
        sidebarType="partnerSideBar"
      >
        <BackToAdminCentre displayText={`${this.props.selectedPartner.Name}: Partner plan`} isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
  partnerPlans: state.partnerPlans,
  partnerPlanAdmin: state.partnerPlanAdmin,
})

export default withRouter(connect(mapStateToProps, { getCurrentOverviewPage })(PartnerPlans))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlans.js